import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axiosInstance from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/api/apiConfig";
import DoctorFormBase from "./DoctorFormBase";
import LoadingScreen from "../common/LoadingScreen";
import ResponseMessage from "../common/ResponseMessage";
import type { Doctor, DoctorFormData } from "../../types";

const DoctorAccountUpdate: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [doctor, setDoctor] = useState<Doctor | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchDoctor = async () => {
      try {
        const response = await axiosInstance.get(
          API_ENDPOINTS.USERS.DOCTORS.GET_BY_ID(parseInt(id!))
        );
        setDoctor(response.data);
        setLoading(false);
      } catch (err) {
        setError("Erreur lors de la récupération des informations du docteur");
        setLoading(false);
        console.error("Error fetching doctor:", err);
      }
    };
    if (id) fetchDoctor();
  }, [id]);

  const handleSubmit = async (data: DoctorFormData) => {
    setIsSubmitting(true);
    setResponseMessage("");
    try {
      await axiosInstance.put(
        API_ENDPOINTS.USERS.DOCTORS.UPDATE(parseInt(id!)),
        data
      );
      setResponseMessage("Compte docteur mis à jour avec succès !");
      setTimeout(() => navigate("/admin/dashboard/account/doctor"), 1500);
    } catch (err) {
      setResponseMessage("Erreur lors de la mise à jour du compte docteur");
      console.error("Error updating doctor:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (loading)
    return (
      <LoadingScreen
        message="Chargement des données du docteur..."
        role="admin"
      />
    );
  if (error || !doctor)
    return (
      <ResponseMessage message={error || "Docteur non trouvé"} role="admin" />
    );

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <DoctorFormBase
        mode="update"
        initialData={doctor}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
      />
      {responseMessage && (
        <ResponseMessage message={responseMessage} role="admin" />
      )}
    </div>
  );
};

export default DoctorAccountUpdate;
